module.exports = __webpack_public_path__ + "static/img/shezhi_tuichu.dccc2e15.png";